import { render, staticRenderFns } from "./TicketIcon.vue?vue&type=template&id=9b39d1d4&"
import script from "./TicketIcon.vue?vue&type=script&lang=ts&"
export * from "./TicketIcon.vue?vue&type=script&lang=ts&"
import style0 from "./TicketIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports